/// <amd-module name="Agile/Common/Utils/QueuedRequestManager/Utils" />
import { IEntityReference } from "./QueuedRequestManager.types";

/// <amd-module name="Agile/Common/Utils/QueuedRequestManager/Utils" />
/**
 * An error indicating that the promise was rejected because a request earlier
 * in the queue triggered a "RequestCompletionBehavior" of "CancelQueued".
 */
export class QueueClearedDueToRejectionError extends Error {
    constructor() {
        super(`Successors of an earlier request were cleared as a result of a chosen completion action.`);

        this.name = this.constructor.name;

        // Required to allow use of "instanceof"
        Object.setPrototypeOf(this, QueueClearedDueToRejectionError.prototype);
    }
}

/**
 * (internal) Produces a key from an entity reference for use in map objects.
 * @param reference the entity reference to use
 */
export function stringifyEntityReference(reference: IEntityReference): string {
    return `${reference.entityType}-${reference.entityId.toString()}`;
}
